import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useOrgPermissions } from '@/hooks/useOrgPermissions';
import { useRequestStatus } from '@/hooks/useRequestStatus';
import { useIsCandidatoContratacao } from '@/hooks/useIsCandidatoContratacao';
import { useNavigate } from 'react-router-dom';

export function useAuthRedirect() {
  const { user, loading: authLoading } = useAuth();
  const { userOrgInfo, loading: orgLoading, shouldRedirectToContratacao, shouldRedirectToEmailConfirmation, shouldRedirectToPendingRequest, shouldRedirectToNoOrg } = useOrgPermissions();
  const { requestStatus, loading: requestLoading } = useRequestStatus();
  const { isCandidato, isLoading: candLoading } = useIsCandidatoContratacao();
  const navigate = useNavigate();

  useEffect(() => {
    // Não redirecionar se ainda estiver carregando dados
    if (authLoading || orgLoading || requestLoading || candLoading || !user) {
      return;
    }

    // PRIORIDADE MÁXIMA: candidato ativo vai SEMPRE para /candidato.
    if (isCandidato) {
      navigate('/candidato', { replace: true });
      return;
    }

    console.log('🔄 useAuthRedirect - Avaliando redirecionamento:', {
      user: user?.email,
      emailConfirmed: user?.email_confirmed_at,
      shouldRedirectToContratacao,
      shouldRedirectToEmailConfirmation,
      shouldRedirectToPendingRequest,
      shouldRedirectToNoOrg,
      userOrgInfo,
      requestStatus
    });

    // PRIORIDADE 1: Verificar se solicitação foi rejeitada
    if (requestStatus === 'rejected') {
      console.log('❌ Redirecionando para /request-rejected');
      navigate('/request-rejected', { replace: true });
      return;
    }

    // PRIORIDADE 2: Redirecionar para confirmação de email se não confirmou ainda
    // IMPORTANTE: Confirmação de email vem ANTES de qualquer outro fluxo
    if (shouldRedirectToEmailConfirmation) {
      console.log('📧 Redirecionando para /email-confirmation (email não confirmado)');
      navigate('/email-confirmation', { replace: true });
      return;
    }

    // PRIORIDADE 3: Redirecionar para processo de contratação se aplicável
    // Só depois que o email foi confirmado
    if (shouldRedirectToContratacao) {
      console.log('📝 Redirecionando para /contratacao');
      navigate('/contratacao', { replace: true });
      return;
    }

    // PRIORIDADE 4: Verificar se há solicitação pendente APENAS se não tem organização
    // Só depois que o email foi confirmado e se não é membro de nenhuma organização
    if ((requestStatus === 'pending' || shouldRedirectToPendingRequest) && !userOrgInfo?.role) {
      console.log('⏳ Redirecionando para /pending-request (solicitação pendente)');
      navigate('/pending-request', { replace: true });
      return;
    }

    // PRIORIDADE 5: Redirecionar para no-organization se não tem organização
    // Só depois que o email foi confirmado e não tem solicitação pendente
    if (shouldRedirectToNoOrg) {
      console.log('🏢 Redirecionando para /no-organization');
      navigate('/no-organization', { replace: true });
      return;
    }

    // Se chegou até aqui e tem organização, redirecionar para intranet
    if (userOrgInfo?.role && ['owner', 'admin', 'member'].includes(userOrgInfo.role)) {
      console.log('✅ Redirecionando para /intranet');
      navigate('/intranet', { replace: true });
    }
  }, [user, authLoading, orgLoading, requestLoading, candLoading, isCandidato, shouldRedirectToContratacao, shouldRedirectToEmailConfirmation, shouldRedirectToPendingRequest, shouldRedirectToNoOrg, userOrgInfo, requestStatus, navigate]);
}